import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

import { UiService } from "@services/ui.service";
import { Address } from '@classes/address';
import { AddressesService } from '@services/addresses.service';


@Injectable()
export class AddressesResolver implements Resolve<Address[]> {
    constructor(
        private addressesSrv: AddressesService,
        private uiSrv: UiService
    ) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Address[]> {
        this.uiSrv.routeLoadingStateChanged.next(true);

        return this.addressesSrv.getList()
        .pipe(
            tap(() => {
                this.uiSrv.routeLoadingStateChanged.next(false);
            })
        );
    }
}
